import { render, staticRenderFns } from "./expense_projection.vue?vue&type=template&id=cfa05c8e&scoped=true&"
import script from "./expense_projection.vue?vue&type=script&lang=js&"
export * from "./expense_projection.vue?vue&type=script&lang=js&"
import style0 from "./expense_projection.vue?vue&type=style&index=0&id=cfa05c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa05c8e",
  null
  
)

export default component.exports